export default __webpack_public_path__ + "static/mai-a-velo-1a12ee6d178dc4e29046f2cbb3437b56.svg";